/** 是否为 GIF 动图 URL（含带 query 的 OSS 地址） */
export function isGifUrl(url) {
  return /\.gif(\?|$)/i.test(url || '');
}
